module.exports = {"540530100":"错那镇","540530200":"勒门巴民族乡","540530201":"贡日门巴民族乡","540530202":"吉巴门巴民族乡","540530203":"麻麻门巴民族乡","540530204":"库局乡","540530205":"曲卓木乡","540530206":"浪波乡","540530207":"觉拉乡","540530208":"卡达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540530.json
// module id = 2537
// module chunks = 0